import { Reducer } from "react"
import { handleActions } from "redux-actions"

export interface silizhuAnimationState {
  animation: any;
  adList: any[];
  adBoard?: any;
}

const initialState: silizhuAnimationState = {
  animation: null,
  adList: [],
  adBoard: null
}

export const silizhuAnimation: Reducer<silizhuAnimationState,any> = handleActions(
  {
    SET_ANIMATION: (state, { payload }) => ({
      ...state,
      animation: payload
    }),
    SET_AD_BOARD: (state, { payload }) => ({
      ...state,
      adBoard: payload
    }),
    ADD_AD: (state, { payload }) => ({
      ...state,
      adList: [...state.adList, payload]
    }),
    REMOVE_AD: (state, { payload }) => ({
      ...state,
      adList: state.adList.filter(ad => ad.id !== payload)
    }),
    // GET_ANIMATION: (state, { payload }) => ({
    //   ...state,
    //   animation: payload
    // }),
  },
  initialState
)